app.Vis.Gauge.MappingTotal = (function () {
    var myVis = function (options) {
        var initOptions = {};
        initOptions = $.extend({}, initOptions, options);
        var gauge = new app.Vis.Gauge(initOptions);

        gauge.update = function () {
            this.data = this.allData;
            //this.filter(this.options.fieldNames.filter1, this.options.year);
            this.drawData();
        };

        return gauge;
    };

    return myVis;
})();
app.Vis.Gauge.MappingByCampus = (function () {
    var myVis = function (options) {
        var initOptions = {};
        initOptions = $.extend({}, initOptions, options);
        var gauge = new app.Vis.Gauge(initOptions);

        gauge.update = function () {
            this.data = this.allData;
            //this.filter(this.options.fieldNames.filter1, this.options.year);
            this.drawData();
        };

        return gauge;
    };

    return myVis;
})();

app.Vis.LineGraph.MappingOverTime = (function () {
    var myVis = function (options) {

        var initOptions = {
            processingFunction : function (data) {
                var parseDate = d3.timeParse("%Y-%m-%d %H:%M");
                data.forEach(function(datum, i) {
                    datum['Date'] = parseDate(datum['Date'])
                });
                data.sort(function(a, b) {
                    return new Date(b.Date) - new Date(a.Date);
                });
                return data;
            },
            xDateScale : true
    };
        initOptions = $.extend({}, initOptions, options);

        var linegraph = new app.Vis.LineGraph(initOptions);

        linegraph.update = function () {
            this.data = this.allData;
            //this.filter(this.options.fieldNames.filter1, this.options.population);
            this.filterCategories(this.options.excludedCategories);
            this.updateScales();
            this.drawData();
        };

        return linegraph;
    };

    return myVis;
})();

//app.Vis.LineGraph.MappingOverTimeCounts = (function () {
//    var myVis = function (options) {

//        var initOptions = {
//            processingFunction: function (data) {
//                var parseDate = d3.timeParse("%Y-%m-%d %H:%M");
//                data.forEach(function (datum, i) {
//                    datum['Date'] = parseDate(datum['Date']);
//                });
//                data.sort(function (a, b) {
//                    return new Date(b.Date) - new Date(a.Date);
//                });
//                return data;
//            },
//            xDateScale: true
//        };
//        initOptions = $.extend({}, initOptions, options);

//        var linegraph = new app.Vis.LineGraph(initOptions);

//        linegraph.update = function () {
//            this.data = this.allData;
//            //this.filter(this.options.fieldNames.filter1, this.options.population);
//            this.filterCategories(this.options.excludedCategories);
//            this.updateScales();
//            this.drawData();
//        };

//        return linegraph;
//    };

//    return myVis;
//})();